const META_PIXEL_ID = '1847425635830345'

declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return

  // Load the Facebook Pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  // Initialize fbq before script loads (queues events)
  if (!window.fbq) {
    const fbq = function (...args: any[]) {
      if (fbq.callMethod) {
        fbq.callMethod(...args)
      } else {
        fbq.queue.push(args)
      }
    } as any
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = [] as any[]
    window.fbq = fbq
    if (!window._fbq) window._fbq = fbq
  }

  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }

  window.fbq('init', META_PIXEL_ID)
  initialized = true
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Guía de Control de Ansiedad',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
